export const translateAppliance = (value: string) => {
    switch (value) {
        case 'AlwaysOn': {
            return 'Standby';
        }
        case 'Refrigeration': {
            return 'Kühlung';
        }
        case 'SpaceHeating': {
            return 'Nachtspeicherofen';
        }
        case 'WaterHeating': {
            return 'Durchlauferhitzer';
        }
        case 'Cooking': {
            return 'Kochen';
        }
        case 'Laundry': {
            return 'Waschen & Trocknen';
        }
        case 'Lighting': {
            return 'Beleuchtung';
        }
        case 'Entertainment': {
            return 'Unterhaltung';
        }
        case 'ElectricVehicle': {
            return 'E-Auto';
        }
        case 'PoolOrSauna': {
            return 'Pool & Sauna';
        }
        case 'Other': {
            return 'Sonstige';
        }
        default: {
            return value;
        }
    }
};

export interface AppliancesDiagramCallout {
    label: string;
    value: string;
    image: string;
    showBoeppel: boolean;
    color: string;
}
